export { useFlag } from '@console/dynamic-plugin-sdk/src/utils/flags';
